import Vue from 'vue'
import Invoice from './Invoice.vue'
import PayInvoice from './PayInvoice.vue'
import RevertInvoice from './RevertInvoice.vue'
import EditInvoice from './EditInvoice.vue'
import AddService from './AddServiceInvoice.vue'
import MergeInvoice from './MergeInvoice.vue'
import AddServicesInvoice from './AddServicesInvoice.vue'
import RemoveServicesInvoice from './RemoveServicesInvoice.vue'

const OpenInvoiceComponent = Vue.extend(Invoice)
const OpenPayInvoiceComponent = Vue.extend(PayInvoice)
const OpenRevertInvoiceComponent = Vue.extend(RevertInvoice)
const OpenEditInvoiceComponent = Vue.extend(EditInvoice)
const OpenAddServiceComponent = Vue.extend(AddService)
const MergeInvoiceComponent = Vue.extend(MergeInvoice)
const AddServicesInvoiceComponent = Vue.extend(AddServicesInvoice)
const RemoveServicesInvoiceComponent = Vue.extend(RemoveServicesInvoice)

export default {
  removeServicesInvoice (propsData) {
    return new RemoveServicesInvoiceComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  addServicesInvoice (propsData) {
    return new AddServicesInvoiceComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openInvoice (propsData) {
    return new OpenInvoiceComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openPayInvoice (propsData) {
    return new OpenPayInvoiceComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openRevertInvoice (propsData) {
    return new OpenRevertInvoiceComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openEditInvoice (propsData) {
    return new OpenEditInvoiceComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  addService (propsData) {
    return new OpenAddServiceComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  mergeInvoice (propsData) {
    return new MergeInvoiceComponent({
      el: document.createElement('div'),
      propsData
    })
  }
}



// WEBPACK FOOTER //
// ./client/components/finances/invoice.js